import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import SectionTitle from "@/components/site/SectionTitle";
import RegisterForm from "@/components/site/RegisterForm";

const Success = ({ login, onReset }) => (
  <div className="text-center py-8" data-testid="register-success">
    <CheckCircle2 className="mx-auto text-sky-300" size={44} />
    <h3 className="font-display text-2xl text-slate-100 mt-4">Konto {login} utworzone</h3>
    <p className="text-slate-400 mt-2">Do zobaczenia w grze!</p>
    <button onClick={onReset} className="mt-6 text-xs tracking-[0.2em] text-amber-400 hover:text-amber-200" data-testid="register-another-btn">Załóż kolejne</button>
  </div>
);

const Disabled = () => <p className="text-slate-400 py-10 text-center" data-testid="register-disabled">Rejestracja zostanie otwarta wkrótce.</p>;

export default function RegisterSection({ settings }) {
  const [done, setDone] = useState("");
  const body = done ? <Success login={done} onReset={() => setDone("")} />
    : settings.registration_enabled ? <RegisterForm onSuccess={setDone} /> : <Disabled />;

  return (
    <section id="register" className="relative py-24 md:py-32 overflow-hidden" data-testid="site-register">
      <img src="/assets/koselig-hero.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#05060f] via-[#05060f]/90 to-[#05060f]/60" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16 items-start">
        <SectionTitle kicker="Dołącz do walki" title="Załóż darmowe konto">
          Jedno konto, trzy imperia. Po rejestracji pobierz klienta i zaloguj się w grze tym samym loginem i hasłem.
        </SectionTitle>
        <div className="steel-panel chamfer" style={{ "--c": "20px" }}><div className="steel-inner chamfer p-8 md:p-10" style={{ "--c": "18.5px" }}>{body}</div></div>
      </div>
    </section>
  );
}
